<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<!-- rederizando componente alert -->
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Comunicados</b>
						</h3>
						<router-link
							tag="a"
							class="btn btn-primary pull-right"
							to="/administracao/comunicados/novo"
							v-if="hasPermission('usuario.write')"
						>
							<i class="fa fa-plus"></i> Novo
						</router-link>
					</div>

					<div class="box-body">
						<div class="row">
							<div class="col-md-7">
								<div class="form-group">
									<input
										type="text"
										class="form-control"
										v-model="filtros.pesquisa"
										placeholder="Pesquisa: Entre com o título do comunicado"
										@keyup.enter="getDataTable"
									/>
								</div>
							</div>

							<div class="col-md-3">
								<div class="form-group">
									<select
										v-model="filtros.situacao"
										class="form-control"
									>
										<option value>--Situação--</option>
										<option value="ATIVO">Ativo</option>
										<option value="INATIVO">Inativo</option>
									</select>
								</div>
							</div>

							<div class="col-md-2">
								<div class="form-group">
									<button
										@click="getDataTable"
										class="btn btn-default btn-block"
									>
										<span class="fa fa-filter"></span>
										Filtrar
									</button>
								</div>
							</div>
						</div>

						<div class="row" style="margin-top: 15px">
							<div
								v-if="
									dataTable.data && dataTable.data.length > 0
								"
								class="col-sm-12"
							>
								<table
									aria-describedby="example1_info"
									role="grid"
									id="example1"
									class="table table-responsive table-bordered table-striped"
								>
									<thead>
										<tr role="row">
											<th style="width: 10%">ID</th>
											<th style="width: 50%">Título</th>
											<th style="width: auto">
												Data Inicial
											</th>
											<th style="width: auto">
												Data Final
											</th>
											<th style="width: auto">
												Situação
											</th>
											<th
												style="width: 8%"
												class="text-center"
											>
												Ação
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											class="even"
											role="row"
											v-for="item in dataTable.data"
											:key="item.id"
										>
											<td>{{ item.id }}</td>
											<td>{{ item.titulo }}</td>
											<td>
												{{
													item.data_inicial
														| dataFormatada
												}}
											</td>
											<td>
												{{
													item.data_final
														| dataFormatada
												}}
											</td>
											<td>{{ item.situacao }}</td>
											<td class="text-center">
												<router-link
													tag="button"
													class="btn btn-warning btn-sm"
													:to="`/administracao/comunicados/atualizacao/${item.id}`"
													title="Editar"
												>
													<i
														style="font-size: 12px"
														class="fa fa-fw fa-edit"
													></i>
												</router-link>
												<button
													class="btn btn-danger btn-sm"
													title="Excluir"
													@click="deletar(item)"
												>
													<i
														style="font-size: 12px"
														class="fa fa-fw fa-times"
													></i>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
								<div class="row">
									<div class="col-sm-5">
										Mostrando {{ this.dataTable.from }} até
										{{ this.dataTable.to }} de
										{{ this.dataTable.total }} registros
										encontrados.
									</div>

									<div
										class="col-sm-7"
										style="text-align: right"
									>
										<laravue-pagination
											:limit="5"
											:data="dataTable"
											v-on:pagination-change-page="
												getDataTable
											"
										>
											<span slot="prev-nav"
												>&lt; Anterior</span
											>
											<span slot="next-nav"
												>Próximo &gt;</span
											>
										</laravue-pagination>
									</div>
								</div>
							</div>
							<div v-else class="col-sm-12">
								Nenhum comunicado foi encontrado.
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http

export default {
	filters: {},
	data: () => ({
		filtros: {
			pesquisa: "",
			situacao: "",
		},
		dataTable: {},
	}),
	mounted() {
		this.filtros.pesquisa = this.$route.query.pesquisa
			? this.$route.query.pesquisa
			: "";
		this.filtros.situacao = this.$route.query.situacao
			? this.$route.query.situacao
			: "";
		this.getDataTable();
	},
	methods: {
		getDataTable(page) {
			if (typeof page === "undefined" || typeof page === "object") {
				page = 1;
			}
			this.filtros.page = page;
			this.$router.push({ query: this.filtros });

			let config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;
			axios
				.get(
					`${this.$store.state.serverURI}/api/administracao/comunicados`,
					config
				)
				.then((response) => {
					this.dataTable = response.data;
				})
				.catch((error) => {
					this.$store.commit("throwException", error);
				});
		},
		deletar(item, index) {
			this.$swal({
				title: 'Exclusão!',
				text: `Confirma exclusão do comunicado ${item.titulo}?`,
				type: "question",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
				cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.$swal({
						title: "Aguarde...",
						imageUrl: "/static/img/Rolling-green.gif",
						showConfirmButton: false,
						allowOutsideClick: false,
					});
					axios
						.delete(
							`${this.$store.state.serverURI}/api/administracao/comunicados/${item.id}`,
							this.$store.getters.getHeaderAuth
						)
						.then((response) => {
							this.getDataTable();
							this.$swal({
								type: "success",
								title: "Confirmado!",
								text: "Comunicado excluído com sucesso!",
								showConfirmButton: false,
								timer: 1500,
							});
						})
						.catch((error) => {
							console.log(error);
						});
				}
			});
		},
	},
	watch: {
		page: function (val) {
			this.getDataTable();
		},
	},

	components: {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// index.vue?eb1fbefc